module.exports = __webpack_public_path__ + "static/media/[Lectures_and_Panels]2014-04-14.c6181247.md";